<div class="tiny-promo">
  <h2>TinyPromo managed cases</h2>

  <p *ngIf="loadError" class="tiny-promo__error" role="status">Managed cases could not be loaded.</p>

  <section class="tiny-promo__card">
    <p>Set promo program</p>
    <input [(ngModel)]="promotionId" name="promotionId" placeholder="promotion id" (change)="loadProgram()" />
    <p *ngIf="loadedProgram" role="status">Current program: {{ loadedProgram }}</p>
    <select [(ngModel)]="program" name="program">
      <option value="" disabled>Load a promotion to see its program</option>
      <option value="TINYPROMO_MANAGED">TINYPROMO_MANAGED</option>
      <option value="STANDARD">STANDARD</option>
    </select>
    <button pButton type="button" label="Set promo program" class="p-button-outlined" (click)="setProgram()"></button>
    <p *ngIf="programMessage === 'success'" role="status">Promo program updated to {{ resultingProgram }}.</p>
    <p *ngIf="programMessage === 'failed'" class="tiny-promo__error" role="status">Promo program was not updated.</p>
  </section>

  <p *ngIf="loaded && !loadError && cases.length === 0" role="status">No managed cases.</p>

  <section class="tiny-promo__card" *ngFor="let row of cases">
    <p><strong>{{ row.promoCode || 'No promoter' }}</strong> · {{ row.program }}</p>
    <p *ngIf="autoConfirmed(row)"><strong>Verified after confirmation window</strong></p>
    <p *ngIf="confirmed(row) && !autoConfirmed(row)"><strong>Verification: Customer confirmed</strong></p>
    <p *ngIf="!confirmed(row)">Managed status: {{ statusLabel(row.status) }}</p>
    <p *ngIf="!confirmed(row)">Verification: {{ outcomeLabel(row.verificationOutcome) }}</p>
    <p>{{ row.whatsAppConnectionState }} · {{ shortRef(row.requestId) }}</p>
    <p>{{ row.promoterEmail || 'No promoter' }}</p>
    <p *ngIf="row.senderMismatch">Sender mismatch</p>
    <a [routerLink]="['/base/promo-managed-cases', row.id]">Open</a>
  </section>
</div>
